import { render, staticRenderFns } from "./organizational_structure.vue?vue&type=template&id=9bd016f0&scoped=true&"
import script from "./organizational_structure.vue?vue&type=script&lang=js&"
export * from "./organizational_structure.vue?vue&type=script&lang=js&"
import style0 from "./organizational_structure.vue?vue&type=style&index=0&id=9bd016f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd016f0",
  null
  
)

export default component.exports